import { Link } from 'react-router-dom';
import { useLanguage } from '@/lib/i18n/LanguageContext';
import { Footer } from '@/components/Footer';
import { Shield, ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';

export function LegalLayout({ title, lastUpdated, children }) {
  const { t, lang } = useLanguage();
  return (
    <div className="min-h-screen bg-[hsl(var(--background))] text-[hsl(var(--foreground))]">
      {/* Header */}
      <header className="sticky top-0 z-50 bg-[hsl(var(--background))]/80 backdrop-blur-xl border-b border-[hsl(var(--border))]">
        <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8 h-14 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2.5">
            <div className="w-8 h-8 rounded-lg bg-[hsl(var(--primary))] flex items-center justify-center">
              <Shield className="w-4 h-4 text-[hsl(var(--primary-foreground))]" />
            </div>
            <span className="text-base font-bold font-['Space_Grotesk'] tracking-tight">Safe Crypto</span>
          </Link>
          <Link to="/">
            <Button variant="ghost" size="sm" className="gap-1.5 text-[hsl(var(--muted-foreground))] hover:text-[hsl(var(--foreground))]">
              <ArrowLeft className="w-4 h-4" />
              {t('legal.home')}
            </Button>
          </Link>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h1 className="text-3xl sm:text-4xl font-bold font-['Space_Grotesk'] mb-2">{title}</h1>
        <p className="text-sm text-[hsl(var(--muted-foreground))] mb-10">
          {t('legal.lastUpdated')}: {lastUpdated}
        </p>
        <article className="prose prose-invert prose-sm max-w-none space-y-6 text-[hsl(var(--muted-foreground))] leading-relaxed [&_h2]:text-[hsl(var(--foreground))] [&_h2]:font-['Space_Grotesk'] [&_h2]:text-xl [&_h2]:font-semibold [&_h2]:mt-10 [&_h2]:mb-4 [&_h3]:text-[hsl(var(--foreground))] [&_h3]:font-medium [&_h3]:text-base [&_h3]:mt-6 [&_h3]:mb-2 [&_strong]:text-[hsl(var(--foreground))] [&_ul]:space-y-1.5 [&_ul]:pl-5 [&_li]:text-sm [&_p]:text-sm">
          {children}
        </article>
      </main>

      <Footer />
    </div>
  );
}
